export const THREAT_HUNTING_FIELDS_SET = 'THREAT_HUNTING_FIELDS_SET'
export const THREAT_HUNTING_FIELDS_REQ = 'THREAT_HUNTING_FIELDS_REQ'
export const THREAT_HUNTING_FIELDS_SUCCESS = 'THREAT_HUNTING_FIELDS_SUCCESS'
export const THREAT_HUNTING_FIELDS_ERROR = 'THREAT_HUNTING_FIELDS_ERROR'
export const THREAT_HUNTING_FIELDS_RESET_STATUS = 'THREAT_HUNTING_FIELDS_RESET_STATUS'

export const THREAT_HUNTING_EVENT_TYPES_SET = 'THREAT_HUNTING_EVENT_TYPES_SET'
export const THREAT_HUNTING_EVENT_TYPES_REQ = 'THREAT_HUNTING_EVENT_TYPES_REQ'
export const THREAT_HUNTING_EVENT_TYPES_SUCCESS = 'THREAT_HUNTING_EVENT_TYPES_SUCCESS'
export const THREAT_HUNTING_EVENT_TYPES_ERROR = 'THREAT_HUNTING_EVENT_TYPES_ERROR'
export const THREAT_HUNTING_EVENT_TYPES_RESET_STATUS = 'THREAT_HUNTING_EVENT_TYPES_RESET_STATUS'

export const THREAT_HUNTING_RECORDS_SET = 'THREAT_HUNTING_RECORDS_SET'
export const THREAT_HUNTING_REQ = 'THREAT_HUNTING_REQ'
export const THREAT_HUNTING_SUCCESS = 'THREAT_HUNTING_SUCCESS'
export const THREAT_HUNTING_ERROR = 'THREAT_HUNTING_ERROR'
export const THREAT_HUNTING_RESET_STATUS = 'THREAT_HUNTING_FIELDS_RESET_STATUS'

export const EVENT_TYPE_VALUES_SET = 'EVENT_TYPE_VALUES_SET'
export const EVENT_TYPE_VALUES_REQ = 'EVENT_TYPE_VALUES_REQ'
export const EVENT_TYPE_VALUES_SUCCESS = 'EVENT_TYPE_VALUES_SUCCESS'
export const EVENT_TYPE_VALUES_ERROR = 'EVENT_TYPE_VALUES_ERROR'
export const EVENT_TYPE_VALUES_RESET_STATUS = 'EVENT_TYPE_VALUES_FIELDS_RESET_STATUS'



// WEBPACK FOOTER //
// ./src/store/modules/threat_hunting/query-fields.type.js